const getCountNumberInPhoneCountry = (format) => format?.split('')
  ?.reduce((acc, el) => (el === '.' ? acc + 1 : acc), 0);
export default getCountNumberInPhoneCountry;
